import { render, staticRenderFns } from "./productForm.vue?vue&type=template&id=b562a750&scoped=true"
import script from "./productForm.vue?vue&type=script&lang=js"
export * from "./productForm.vue?vue&type=script&lang=js"
import style0 from "./productForm.vue?vue&type=style&index=0&id=b562a750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b562a750",
  null
  
)

export default component.exports